import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmapItemComponentProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import {
    EXTRA_LARGE,
    LARGE,
    LARGE_SHORT,
    MEDIUM,
    MEDIUM_SHORT,
    SMALL,
    SMALL_LONG,
} from 'components/Dashboards/Reporting/reportingConfig';

export const automatedNarrative: IHashmapItemComponentProps = {
    NoPermissionMessage,
    componentKey: 'automatedNarrative',
    id: 'automatedNarrative',
    title: 'Automated Narrative',
    permission: 'ReportsView',
    reportConfig: {
        buttons: {
            narrative: false,
        },
    },

    reportStyle: {
        widgetSizesAvailable: {
            small: SMALL,
            smallLong: SMALL_LONG,
            mediumShort: MEDIUM_SHORT,
            medium: MEDIUM,
            largeShort: LARGE_SHORT,
            large: LARGE,
            extraLarge: EXTRA_LARGE,
            custom: 'custom',
        },
        widgetInitialSize: LARGE_SHORT,
        isResizable: true,
        minHeight: 1,
        minWidth: SMALL.w,
        maxHeight: EXTRA_LARGE.h,
        maxWidth: EXTRA_LARGE.w,
    },
};
